import type { Holerite } from '../../models/holerite.model';
import type { FormatoRemessaHolerite } from '../../services/holerites.service';

export interface DuplicidadeRemessa {
  documentos: Holerite[];
  maisRecente: Holerite | null;
}

/** Apenas analisa a seleção. Não altera nem exclui documentos persistidos. */
export function duplicidadesRemessa(
  documentos: Holerite[], formato: FormatoRemessaHolerite, configuracao: Record<string, string>
): DuplicidadeRemessa[] {
  if (formato === 'cnab400' && configuracao['tipoArquivo'] === 'X') return [];
  const grupos = new Map<string, Holerite[]>();
  const campo = (h: Holerite, k: string): string => (h.dados[k] || '').trim();
  const digitos = (s: string): string => s.replace(/\D/g, '');
  const numero = (s: string): string => s.replace(/^0+(?=\d)/, '');
  const pagamento = (h: Holerite): string => campo(h, 'dataPagamento') || (configuracao['dataPagamento'] || '').trim();
  const periodo = (h: Holerite): string => JSON.stringify([
    campo(h, 'competencia'), campo(h, 'tipoContracheque'), campo(h, 'tipoPagamento'), pagamento(h)
  ]);
  for (const h of documentos) {
    // Dados incompletos precisam de correção, nunca de descarte por agrupamento.
    const empresa = digitos(campo(h, 'empresaCnpj'));
    const matricula = campo(h, 'funcionarioMatricula');
    const agencia = campo(h, 'funcionarioAgencia'), conta = campo(h, 'funcionarioConta');
    if (!h.id || !empresa || !matricula || !agencia || !conta) continue;
    let chave: string[];
    if (formato === 'cnab200') {
      if (!campo(h, 'competencia') || !campo(h, 'tipoContracheque') || !pagamento(h)) continue;
      chave = [empresa, matricula, agencia, conta, campo(h, 'competencia'), campo(h, 'tipoContracheque'), pagamento(h)];
    } else {
      const cpf = digitos(campo(h, 'funcionarioCpf')), banco = digitos(campo(h, 'funcionarioBanco'));
      if (!cpf || !banco || !/^\d+$/.test(matricula) || !/^\d+$/.test(agencia) || !/^\d+$/.test(conta)) continue;
      chave = [empresa, cpf, numero(banco), numero(agencia), numero(conta), numero(matricula)];
    }
    const key = JSON.stringify(chave);
    const grupo = grupos.get(key) || [];
    grupo.push(h); grupos.set(key, grupo);
  }
  return [...grupos.values()].filter(g => g.length > 1).map(grupo => {
    const data = (h: Holerite): number => Date.parse(h.criadoEm || '');
    const documentos = [...grupo].sort((a, b) => (data(b) || 0) - (data(a) || 0));
    // Empates, datas ausentes e pagamentos distintos exigem escolha manual.
    const maisRecente = documentos.every(h => Number.isFinite(data(h))) &&
      data(documentos[0]) > data(documentos[1]) && new Set(documentos.map(periodo)).size === 1
      ? documentos[0] : null;
    return { documentos, maisRecente };
  });
}
